export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9659.6ab7afec.jpg";